import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Briefcase, Landmark, Mic2, Palette, Cpu, Heart, Check, ChevronDown } from "lucide-react";

const ICONS = { Briefcase, Landmark, Mic2, Palette, Cpu, Heart };
const PREVIEW_COUNT = 5;

const ServiceCard = ({ category, index }) => {
  const [expanded, setExpanded] = useState(false);
  const Icon = ICONS[category.icon] || Briefcase;
  const visible = expanded ? category.services : category.services.slice(0, PREVIEW_COUNT);
  const hiddenCount = category.services.length - PREVIEW_COUNT;

  return (
    <motion.article
      data-testid={`service-card-${category.id}`}
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.55, delay: (index % 3) * 0.1, ease: "easeOut" }}
      className="group flex h-full flex-col rounded-2xl border border-[#F0F0F0] bg-white p-7 shadow-[0_6px_24px_rgba(0,0,0,0.05)] transition-all duration-300 hover:-translate-y-2 hover:shadow-[0_20px_45px_rgba(198,40,40,0.12)]"
    >
      <div className="flex items-center gap-4">
        <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-[#C62828] text-white shadow-[0_8px_20px_rgba(198,40,40,0.3)] transition-transform duration-300 group-hover:scale-110">
          <Icon size={24} strokeWidth={2} />
        </span>
        <h3 className="text-lg font-extrabold uppercase tracking-wide text-[#1F1F1F]">
          {category.title}
        </h3>
      </div>

      <p className="mt-4 text-sm leading-relaxed text-[#666666]">{category.description}</p>

      <ul className="mt-5 grid flex-1 content-start gap-x-4 gap-y-2.5 sm:grid-cols-2">
        <AnimatePresence initial={false}>
          {visible.map((service) => (
            <motion.li
              key={service}
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: "auto" }}
              exit={{ opacity: 0, height: 0 }}
              transition={{ duration: 0.25 }}
              className="flex items-start gap-2 overflow-hidden text-[13px] font-medium text-[#444444]"
            >
              <Check size={15} strokeWidth={3} className="mt-0.5 shrink-0 text-[#C62828]" />
              {service}
            </motion.li>
          ))}
        </AnimatePresence>
      </ul>

      <button
        data-testid={`service-card-${category.id}-toggle`}
        onClick={() => setExpanded((v) => !v)}
        className="mt-6 inline-flex items-center gap-2 self-start rounded-full border border-[#C62828]/25 px-5 py-2.5 text-xs font-bold uppercase tracking-wider text-[#C62828] transition-all duration-300 hover:bg-[#C62828] hover:text-white"
      >
        {expanded ? "Show Less" : `Explore ${hiddenCount} More Services`}
        <ChevronDown size={15} strokeWidth={2.5} className={`transition-transform duration-300 ${expanded ? "rotate-180" : ""}`} />
      </button>
    </motion.article>
  );
};

export default ServiceCard;
